export default function(input) {
  $(input).change(function() {
    if($(input).prop('checked')) {
      $('html, body').css('overflow', 'hidden');
    } else {
      $('html, body').css('overflow', 'auto');
    }
  });
};
